import { render, staticRenderFns } from "./BeaconsCreatePage.vue?vue&type=template&id=001ce034&"
import script from "./BeaconsCreatePage.vue?vue&type=script&lang=js&"
export * from "./BeaconsCreatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports